import React from 'react';
import Joyride from 'react-joyride';
import { useTranslation } from "react-i18next";

const DashboardGuidedTour = ({ isTourOpen, closeTour, currentPage }) => {
  const { t } = useTranslation();

  var steps = null;
  switch (currentPage) {
    case 'schedule': {
      steps = [
        {
          target: '.clickableCursor', // Selector for the FullCalendar element
          content: t('calendarSteps1'),
          placement: 'auto',
          disableBeacon: true,
        },
        {
          target: '.add-entry-button', // Selector for the "Add Entry" button
          content: t('calendarSteps2'),
          placement: 'top',
          disableBeacon: true,
        },
        {
          target: '.addToCalendarButton', // Selector for the "Add to Calendar" button
          content: t('calendarSteps3'),
          placement: 'top',
          disableBeacon: true,
        },
      ];
      break;
    }
    case 'feedback': {
      steps = [
        {
          target: '.feedbackForm',
          content: t('feedbackSteps1'),
          placement: 'left',
          disableBeacon: true,
        }
      ];
      break;
    }
    case 'library': {
      steps = [
        {
          target: '.preferenceSelector',
          content: t('librarySteps1'),
          placement: 'auto',
          disableBeacon: true,
        },
        {
          target: '.libraryGrid',
          content: t('librarySteps2'),
          placement: 'top-end',
          disableBeacon: true,
        },
      ];
      break;
    }
    case 'settings': {
      steps = [
        {
          target: '.settingsDivider',
          content: t('settingsSteps1'),
          placement: 'top-end',
          disableBeacon: true,
        },
        {
          target: '.movementSwitch',
          content: t('settingsSteps2'),
          placement: 'auto',
          disableBeacon: true,
        },
        {
          target: '.movementSnoozeSwitch',
          content: t('settingsSteps3'),
          placement: 'auto',
          disableBeacon: true,
        },
        {
          target: '.movementCard',
          content: t('settingsSteps4'),
          placement: 'auto',
          disableBeacon: true,
        },
        {
          target: '.exerciseToggleButton',
          content: t('clickHere'),
          placement: 'auto',
          disableBeacon: true,
          spotlightClicks: true,
        },
        {
          target: '.exerciseSwitch',
          content: t('settingsSteps5'),
          placement: 'auto',
          disableBeacon: true,
        },
        {
          target: '.exerciseSnoozeSwitch',
          content: t('settingsSteps6'),
          placement: 'auto',
          disableBeacon: true,
        },
        {
          target: '.exerciseCard',
          content: t('settingsSteps7'),
          placement: 'auto',
          disableBeacon: true,
        },
      ];
      break;
    }
    default: {
      steps = [];
    }
  }

  return (
    <Joyride
      steps={steps}
      continuous={true}
      showSkipButton={false}
      run={isTourOpen}
      styles={{
        options: {
          arrowColor: '#1a76d2',
          primaryColor: '#1a76d2',
          width: 500,
          zIndex: 1000,
        }
      }}
      locale={{
        back: t('back'),
        close: t('close'),
        last: t('last'),
        next: t('next'),
        skip: t('skip'),
      }}
      callback={(data) => {
        if (data.action === 'close' || data.status === 'finished') {
          closeTour();
        }
      }}
    />
  );
};

export default DashboardGuidedTour;